<template>
  <div class="llp-radio d-flex gap-4">
    <div v-for="option in options" :key="reduce(option)" class="form-check">
      <input 
        :id="`${id}-${reduce(option)}`" 
        :name="id" 
        type="radio" 
        class="form-check-input mt-2" 
        :value="reduce(option)" 
        v-model="componentModel" 
        :disabled="disabled"
        @change="$emit('update:modelValue', componentModel)" 
      />
      <label :for="`${id}-${reduce(option)}`" class="form-check-label mt-1">
        {{ label(option) }}
      </label>
    </div>
    <span v-if="errors.length === 1" class="text-danger">
      {{ errors[0].$message }}
    </span>
    <ul v-else-if="errors.length > 1" class="m-0">
      <li v-for="error in errors" :key="error.$uid" class="text-danger">
        <span class="text-danger">{{ error.$message }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BaseRadio',
  data() {
    return {
      componentModel: this.modelValue,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    reduce: {
      type: Function,
      required: false,
      default: option => option.id,
    },
    label: {
      type: Function,
      required: false,
      default: option => option.name,
    },
    modelValue: {
      type: [Object, Number, String],
      required: false,
      default: null,
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(newValue) {
      this.componentModel = newValue;  
    },
  },
};
</script>
